let statuses = [
    { title: 'Unpaid', value: 'unpaid' },
    { title: 'Paid', value: 'paid' },
    { title: 'Partial', value: 'partial' },
];
export default statuses;
